// src/i18n.js

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import translationEN from './locals/en/translation.json';
import translationHI from './locals/hi/translation.json';
import translationTA from './locals/ta/translation.json';
import translationJA from './locals/ja/translation.json';
import translationES from './locals/es/translation.json';
import translationFR from './locals/fr/translation.json';
import translationDE from './locals/de/translation.json';
import translationAS from './locals/as/translation.json';
import translationBN from './locals/bn/translation.json';
import translationGU from './locals/gu/translation.json';
import translationRU from './locals/ru/translation.json';
import translationKN from './locals/kn/translation.json';
import translationML from './locals/ml/translation.json';
import translationTE from './locals/te/translation.json';
import translationIT from './locals/it/translation.json';
import translationMR from './locals/mr/translation.json';
import translationPA from './locals/pa/translation.json';
import translationOR from './locals/or/translation.json';
import translationUR from './locals/ur/translation.json';
import translationNE from './locals/ne/translation.json';
import translationKO from './locals/ko/translation.json';
import translationMA from './locals/ma/translation.json';

// Configure the resources
const resources = {
  en: {
    translation: translationEN
  },
  hi: {
    translation: translationHI
  },
  ta: {
    translation: translationTA
  },
  ja: {
    translation: translationJA
  },
  es: {
    translation: translationES
  },
  fr: {
    translation: translationFR
  },
  de: {
    translation: translationDE
  },
  ru: {
    translation: translationRU
  },
  as: {
    translation: translationAS
  },
  bn: {
    translation: translationBN
  },
  gu: {
    translation: translationGU
  },
  kn: {
    translation: translationKN
  },
  ml: {
    translation: translationML
  },
  te: {
    translation: translationTE
  },
  it: {
    translation: translationIT
  },
  mr: {
    translation: translationMR
  },
  pa: {
    translation: translationPA
  },
  or: {
    translation: translationOR
  },
  ur: {
    translation: translationUR
  },
  ne: {
    translation: translationNE
  },
  ko: {
    translation: translationKO
  },
  ma: {
    translation: translationMA
  },

};

// Initialize i18next
i18n
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources,
    lng: 'en', // Default language
    fallbackLng: 'en',

    interpolation: {
      escapeValue: false // React already protects from XSS
    }
  });

export default i18n;